import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Mail } from '../../interfaces/mail.interface';

const apiSalud =  "https://api.saludmunirengo.cl/api/v1/";
const establecimiento = "RIENZI";

@Injectable({
  providedIn: 'root'
})


export class SaludService {
  constructor(private http: HttpClient){}

  validarRut(rut: string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };
    const body = {
      rutPortal: rut,
      sheetName: establecimiento,
      sheetId: '1kFuKkCMgkz3kmbgB7N1l0mXS4lcSoxkIen4YYKwWEYw'
    };
    return this.http.post(`${apiSalud}getPaciente/`, body, httpOptions)
  }

  validarFecha(){
    return this.http.get(`${apiSalud}util/utilDate/getDateHour`);
  }

  sendMail(content: Mail){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };
    const body = {
      to: content.to,
      subject: content.subject,
      text: content.body
    }
    return this.http.post(`${apiSalud}util/utilMail/sendMail`, body, httpOptions)
  }
}
